import moment from "moment";

let listViewBtn;
let calViewBtn;

let CalView;
let listView;

let blueListIcon;
let greyListIcon;
let blueCalIcon;
let greyCalIcon;

let eventlistBody;
let eventListHeader;

let backFromEvent;
let backFromDay;

let eventPage;
let singeDayEventList;

let singleDayDataTarget;

let calendarActive = false;

let deviceMobile;

const monthNames = [
    "Januar",
    "Februar",
    "Marts",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "December"
];

const weekdayNames = [
    "Mandag",
    "Tirsdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lørdag",
    "Søndag"
];

// Formatting for turning 19/3/2022 into 19/03/2022
function minTwoDigits(num) {
    return num.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false
    });
}

window.mobileCheck = function() {
    let check = false;
    (function(a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

// function for filtering data (taking both a month and year) and inserting in list
function findDataWithDate(month, year) {
    let providedMonth = month + 1;
    let filteredDataArr = [];
    data.forEach(monthData => {
        if (Number(monthData.month) === providedMonth) {
            let eventDate = new Date(monthData.tableEvents[0].eventDateStart);
            let eventYear = eventDate.getFullYear();
            if (eventYear === year) {
                monthData.tableEvents.forEach(event => {
                    filteredDataArr.push(event);
                });
            }
        }
    });

    // Clear list
    let prevData = $("div.eventlistEvents");
    if (prevData.length >= 2) {
        for (let i = 0; i < prevData.length; i++) {
            prevData[i].remove();
        }
    } else if (prevData.length === 1) {
        prevData.remove();
    }
    prevData = [];

    let monthContainer = document.createElement("div");
    monthContainer.classList.add("eventlistEvents");
    let noEventEl = $(".no-events");
    noEventEl.hide();
    let tableHeader = $(".eventlist-body-list-topics");
    tableHeader.show();

    if (filteredDataArr.length > 0) {
        tableHeader.show();
        filteredDataArr.forEach(event => {
            let timeForEvent = new Date(event.eventDateStart);
            let displayDate =
                minTwoDigits(timeForEvent.getDate()) +
                "/" +
                minTwoDigits(timeForEvent.getMonth() + 1) +
                "/" +
                timeForEvent.getFullYear();
            let displayTime =
                minTwoDigits(timeForEvent.getHours()) +
                ":" +
                minTwoDigits(timeForEvent.getMinutes());

            let newEvent = document.createElement("a");
            newEvent.setAttribute("href", event.eventPage);
            let eventContainer = document.createElement("div");
            eventContainer.classList.add("eventlist-body-list-item");

            let eventTitle = document.createElement("div");
            eventTitle.classList.add("topic-title");
            let eventTitleSpan = document.createElement("span");
            eventTitleSpan.innerText = event.title;
            eventTitle.append(eventTitleSpan);

            let eventDate = document.createElement("div");
            eventDate.classList.add("topic-date");
            let eventDateSpan = document.createElement("span");
            eventDateSpan.innerText = displayDate;
            eventDate.append(eventDateSpan);

            let eventTime = document.createElement("div");
            eventTime.classList.add("topic-time");
            let eventTimeSpan = document.createElement("span");
            eventTimeSpan.innerText = displayTime;
            eventTime.append(eventTimeSpan);

            let eventLocation = document.createElement("div");
            eventLocation.classList.add("topic-location");
            let eventLocationSpan = document.createElement("span");
            eventLocationSpan.innerText = event.location;
            eventLocation.append(eventLocationSpan);

            let eventDownload = document.createElement("div");
            eventDownload.classList.add("topic-download-cal");
            eventDownload.classList.add("calendar-download");
            eventDownload.setAttribute("data-eventtitle", event.title);
            eventDownload.setAttribute("data-eventlocation", event.location);
            eventDownload.setAttribute("data-eventdesc", event.description);
            eventDownload.setAttribute("data-eventdatestart", timeForEvent);
            eventDownload.setAttribute(
                "data-eventdateend",
                new Date(event.eventDateEnd)
            );
            let eventDownloadIcon = document.createElement("img");
            eventDownloadIcon.setAttribute("src", "/Images/calendar.svg");
            eventDownloadIcon.setAttribute("alt", "download calender event");
            eventDownload.append(eventDownloadIcon);

            eventContainer.append(
                eventTitle,
                eventDate,
                eventTime,
                eventLocation,
                eventDownload
            );
            newEvent.append(eventContainer);
            monthContainer.append(newEvent);
        });
    } else {
        let noEventEl = $(".no-events");
        noEventEl.show();
        tableHeader.hide();
    }
    listView.append(monthContainer);
}

$(document).ready(function() {
    deviceMobile = window.mobileCheck();

    let todayYear = new Date().getFullYear();
    let todayMonth = new Date();
    $("#currentYear").text(todayYear);
    $("#currentMonth").text(monthNames[todayMonth.getMonth()]);
    $("#prevMonthLabel").text(monthNames[todayMonth.getMonth() - 1]);
    $("#nextMonthLabel").text(monthNames[todayMonth.getMonth() + 1]);

    $(".eventlist-body-list > .carousel").carousel({
        interval: false
    });
    listViewBtn = $("#listView");
    calViewBtn = $("#calView");

    listView = $(".eventlist-body-list");
    CalView = $(".eventlist-body-calendar");

    blueListIcon = $("#blueList");
    greyListIcon = $("#greyList");
    blueCalIcon = $("#blueCal");
    greyCalIcon = $("#greyCal");

    eventlistBody = $(".eventlist-body");
    eventListHeader = $(".eventlist-header");

    eventPage = $("#event");
    singeDayEventList = $("#events-for-day");
    singleDayDataTarget = $("#singeDayData");

    backFromEvent = $("#back-from-event");
    backFromDay = $("#back-from-day");

    function listViewActive() {
        eventPage.hide();
        singeDayEventList.hide();
        eventlistBody.show();
        eventListHeader.show();
        CalView.hide();
        listView.show();
        listViewBtn.addClass("active");
        calViewBtn.removeClass("active");
        greyListIcon.hide();
        blueListIcon.show();
        blueCalIcon.hide();
        greyCalIcon.show();
        calendarActive = false;
    }

    function calViewActive() {
        eventPage.hide();
        singeDayEventList.hide();
        eventlistBody.show();
        eventListHeader.show();
        listView.hide();
        CalView.show();
        listViewBtn.removeClass("active");
        calViewBtn.addClass("active");
        blueListIcon.hide();
        greyListIcon.show();
        greyCalIcon.hide();
        blueCalIcon.show();
        calendarActive = true;
    }

    listViewBtn.on("click", function() {
        listViewActive();
    });

    calViewBtn.on("click", function() {
        calViewActive();
    });

    backFromEvent.on("click", function() {
        if (calendarActive) {
            calViewActive();
        } else {
            listViewActive();
        }
    });

    backFromDay.on("click", function() {
        if (calendarActive) {
            calViewActive();
        } else {
            listViewActive();
        }
    });
});

//* CALENDAR CODE from here

// Example of data
// [
//     {
//         id: 1,
//         time: "2022-03-13T21:00:00 Z",
//         cls: "bg-dark-cyan",
//         desc: "Jack, Stephen"
//     },
//     {
//         id: 2,
//         time: "2022-03-13T22:00:00 Z",
//         cls: "bg-dark-cyan",
//         desc: "Nathan, Luke"
//     }
// ]

let newData = [];
let rawData = [];
let data;
$(document).ready(function() {
    if ($("#event-data")[0]) {
        rawData = $("#event-data")[0].dataset.data;
        data = JSON.parse(rawData);
        data.forEach(x => {
            x.tableEvents.forEach(event => {
                event.cls = "bg-dark-cyan";
                newData.push(event);
            });
        });
    }

    // LISTVIEW CODE

    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    let noEvents = $(".no-events");
    let anyEventsThisMonth = false;
    let topics = $(".eventlist-body-list-topics");
    if (data) {
        data.forEach(data => {
            let monthContainer = document.createElement("div");
            monthContainer.classList.add("eventlistEvents");

            if (data.tableEvents.length > 0) {
                let eventDate = new Date(data.tableEvents[0].eventDateStart);
                let eventYear = eventDate.getFullYear();

                // IF the month and year matches - then create list elements and insert them
                if (
                    Number(data.month) === currentMonth &&
                    eventYear === currentYear
                ) {
                    anyEventsThisMonth = true;
                    data.tableEvents.forEach(event => {
                        let timeForEvent = new Date(event.eventDateStart);
                        let displayDate =
                            minTwoDigits(timeForEvent.getDate()) +
                            "/" +
                            minTwoDigits(timeForEvent.getMonth() + 1) +
                            "/" +
                            timeForEvent.getFullYear();
                        let displayTime =
                            minTwoDigits(timeForEvent.getHours()) +
                            ":" +
                            minTwoDigits(timeForEvent.getMinutes());

                        let newEvent = document.createElement("a");
                        newEvent.setAttribute("href", event.eventPage);
                        let eventContainer = document.createElement("div");
                        eventContainer.classList.add(
                            "eventlist-body-list-item"
                        );

                        let eventTitle = document.createElement("div");
                        eventTitle.classList.add("topic-title");
                        let eventTitleSpan = document.createElement("span");
                        eventTitleSpan.innerText = event.title;
                        eventTitle.append(eventTitleSpan);

                        let eventDate = document.createElement("div");
                        eventDate.classList.add("topic-date");
                        let eventDateSpan = document.createElement("span");
                        eventDateSpan.innerText = displayDate;
                        eventDate.append(eventDateSpan);

                        let eventTime = document.createElement("div");
                        eventTime.classList.add("topic-time");
                        let eventTimeSpan = document.createElement("span");
                        eventTimeSpan.innerText = displayTime;
                        eventTime.append(eventTimeSpan);

                        let eventLocation = document.createElement("div");
                        eventLocation.classList.add("topic-location");
                        let eventLocationSpan = document.createElement("span");
                        eventLocationSpan.innerText = event.location;
                        eventLocation.append(eventLocationSpan);

                        let eventDownload = document.createElement("div");
                        eventDownload.classList.add("topic-download-cal");
                        eventDownload.classList.add("calendar-download");
                        eventDownload.setAttribute(
                            "data-eventtitle",
                            event.title
                        );
                        eventDownload.setAttribute(
                            "data-eventlocation",
                            event.location
                        );
                        eventDownload.setAttribute(
                            "data-eventdesc",
                            event.description
                        );
                        eventDownload.setAttribute(
                            "data-eventdatestart",
                            timeForEvent
                        );
                        eventDownload.setAttribute(
                            "data-eventdateend",
                            new Date(event.eventDateEnd)
                        );
                        let eventDownloadIcon = document.createElement("img");
                        eventDownloadIcon.setAttribute(
                            "src",
                            "/Images/calendar.svg"
                        );
                        eventDownloadIcon.setAttribute(
                            "alt",
                            "download calender event"
                        );
                        eventDownload.append(eventDownloadIcon);

                        eventContainer.append(
                            eventTitle,
                            eventDate,
                            eventTime,
                            eventLocation,
                            eventDownload
                        );
                        newEvent.append(eventContainer);
                        monthContainer.append(newEvent);
                    });
                }
            }
            listView.append(monthContainer);
        });
    }
    // Show/Hide no-events message
    if (anyEventsThisMonth) {
        topics.show();
        noEvents.hide();
    } else {
        topics.hide();
        noEvents.show();
    }
});

export const Spinner = id => ({
    id: id,
    el: null,
    renderSpinner() {
        const frgSpinner = document.createRange().createContextualFragment(`
                <div class="spinner d-flex justify-content-center align-items-center">
                <div class="spinner-grow text-light" style="width: 4rem; height: 4rem;" role="status">
                <span class="sr-only">Loading...</span>
        </div>
        </div>
        `);
        this.el = document.getElementById(this.id);
        this.el.innerHTML = ""; //replacing
        this.el.appendChild(frgSpinner);
        return this;
    },
    async delay(delay = 2000) {
        await new Promise(resolve => setTimeout(resolve, delay));
    }
});

const StopEventPropagation = e => {
    if (!e) return;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
};
export const Calendar = id => ({
    id: id,
    data: [],
    el: undefined,
    y: undefined,
    m: undefined,
    onMeatballClick(e) {
        StopEventPropagation(e);
        const el = e.srcElement;
        $(".eventlist-body").hide();
        $(".eventlist-header").hide();
        $(".eventlist-event").hide();
        $("#events-for-day").show();

        let todaysEvents;

        let weekday = e.target.dataset.weekday - 1;
        let day = e.target.dataset.day;
        let month = e.target.dataset.month;
        let year = e.target.dataset.year;

        let theDate = new Date();
        theDate.setFullYear(year);
        theDate.setMonth(month);
        theDate.setDate(day);

        let dateLabel =
            weekdayNames[weekday] +
            ", " +
            day +
            " " +
            monthNames[month] +
            " " +
            year;
        $(".picked-date").text(dateLabel);

        todaysEvents = newData.filter(event => {
            let date = new Date(event.eventDateStart);

            if (
                date.getFullYear() === theDate.getFullYear() &&
                date.getMonth() === theDate.getMonth() &&
                date.getDate() === theDate.getDate()
            ) {
                return event;
            }
        });

        //Delete event from last time
        let prevData = $("a.single-day-event");
        if (prevData.length >= 2) {
            for (let i = 0; i < prevData.length; i++) {
                prevData[i].remove();
            }
        } else if (prevData.length === 1) {
            prevData.remove();
        }
        prevData = [];

        // Show events for day
        todaysEvents.forEach(event => {
            let timeForEvent = new Date(event.eventDateStart);
            let displayTime =
                minTwoDigits(timeForEvent.getHours()) +
                ":" +
                minTwoDigits(timeForEvent.getMinutes());
            let newEvent = document.createElement("a");
            newEvent.setAttribute("href", event.eventPage);
            newEvent.classList.add("single-day-event");
            let eventContainer = document.createElement("div");
            eventContainer.classList.add("eventlist-day-body-item");

            let eventTitle = document.createElement("div");
            eventTitle.classList.add("topic-title");
            let eventTitleSpan = document.createElement("span");
            eventTitleSpan.innerText = event.title;
            eventTitle.append(eventTitleSpan);

            let eventTime = document.createElement("div");
            eventTime.classList.add("topic-time");
            let eventTimeSpan = document.createElement("span");
            eventTimeSpan.innerText = displayTime;
            eventTime.append(eventTimeSpan);

            let eventLocation = document.createElement("div");
            eventLocation.classList.add("topic-location");
            let eventLocationSpan = document.createElement("span");
            eventLocationSpan.innerText = event.location;
            eventLocation.append(eventLocationSpan);

            let eventDownload = document.createElement("div");
            eventDownload.classList.add("topic-download-cal");
            eventDownload.classList.add("calendar-download");
            eventDownload.setAttribute("data-eventtitle", event.title);
            eventDownload.setAttribute("data-eventlocation", event.location);
            eventDownload.setAttribute("data-eventdesc", event.description);
            eventDownload.setAttribute("data-eventdatestart", timeForEvent);
            eventDownload.setAttribute(
                "data-eventdateend",
                new Date(event.eventDateEnd)
            );
            let eventDownloadIcon = document.createElement("img");
            eventDownloadIcon.setAttribute("src", "/Images/calendar.svg");
            eventDownloadIcon.setAttribute("alt", "download calender event");
            eventDownload.append(eventDownloadIcon);

            eventContainer.append(
                eventTitle,
                eventTime,
                eventLocation,
                eventDownload
            );
            newEvent.append(eventContainer);
            singleDayDataTarget.append(newEvent);
        });
    },
    onMobileDayClick(e) {
        StopEventPropagation(e);
        $(".eventlist-body").hide();
        $(".eventlist-header").hide();
        $(".eventlist-event").hide();
        $("#events-for-day").show();

        let todaysEvents;

        let dataPath;
        if (e.target.localName === "li") {
            dataPath = e.target.dataset;
        } else {
            dataPath = e.path[1].dataset;
        }
        let weekday = dataPath.weekday;
        let day = dataPath.day;
        let month = dataPath.month;
        let year = dataPath.year;

        let theDate = new Date();
        theDate.setFullYear(year);
        theDate.setMonth(month);
        theDate.setDate(day);

        let dateLabel =
            weekdayNames[weekday - 1] +
            ", " +
            day +
            " " +
            monthNames[month] +
            " " +
            year;
        $(".picked-date").text(dateLabel);

        todaysEvents = newData.filter(event => {
            let date = new Date(event.eventDateStart);

            if (
                date.getFullYear() === theDate.getFullYear() &&
                date.getMonth() === theDate.getMonth() &&
                date.getDate() === theDate.getDate()
            ) {
                return event;
            }
        });

        //Delete event from last time
        let prevData = $("a.single-day-event");
        if (prevData.length >= 2) {
            for (let i = 0; i < prevData.length; i++) {
                prevData[i].remove();
            }
        } else if (prevData.length === 1) {
            prevData.remove();
        }
        prevData = [];

        // Show events for day
        todaysEvents.forEach(event => {
            let timeForEvent = new Date(event.eventDateStart);
            let displayTime =
                minTwoDigits(timeForEvent.getHours()) +
                ":" +
                minTwoDigits(timeForEvent.getMinutes());

            let newEvent = document.createElement("a");
            newEvent.setAttribute("href", event.eventPage);
            newEvent.classList.add("single-day-event");
            let eventContainer = document.createElement("div");
            eventContainer.classList.add("eventlist-day-body-item");

            let eventTitle = document.createElement("div");
            eventTitle.classList.add("topic-title");
            let eventTitleSpan = document.createElement("span");
            eventTitleSpan.innerText = event.title;
            eventTitle.append(eventTitleSpan);

            let eventTime = document.createElement("div");
            eventTime.classList.add("topic-time");
            let eventTimeSpan = document.createElement("span");
            eventTimeSpan.innerText = displayTime;
            eventTime.append(eventTimeSpan);

            let eventLocation = document.createElement("div");
            eventLocation.classList.add("topic-location");
            let eventLocationSpan = document.createElement("span");
            eventLocationSpan.innerText = event.location;
            eventLocation.append(eventLocationSpan);

            let eventDownload = document.createElement("div");
            eventDownload.classList.add("topic-download-cal");
            eventDownload.classList.add("calendar-download");
            eventDownload.setAttribute("data-eventtitle", event.title);
            eventDownload.setAttribute("data-eventlocation", event.location);
            eventDownload.setAttribute("data-eventdesc", event.description);
            eventDownload.setAttribute("data-eventdatestart", timeForEvent);
            eventDownload.setAttribute(
                "data-eventdateend",
                new Date(event.eventDateEnd)
            );
            let eventDownloadIcon = document.createElement("img");
            eventDownloadIcon.setAttribute("src", "/Images/calendar.svg");
            eventDownloadIcon.setAttribute("alt", "download calender event");
            eventDownload.append(eventDownloadIcon);

            eventContainer.append(
                eventTitle,
                eventTime,
                eventLocation,
                eventDownload
            );
            newEvent.append(eventContainer);
            singleDayDataTarget.append(newEvent);
        });
    },

    // onEventClick(e) {},

    bindData(events) {
        this.data = events.sort((a, b) => {
            if (a.time < b.time) return -1;
            if (a.time > b.time) return 1;
            return 0;
        });
    },
    renderEvents() {
        if (!this.data || this.data.length <= 0) return;
        const lis = this.el.querySelectorAll(`.${this.id} .days .inside`);
        let y = this.el.querySelector(".month-year .year").innerText;
        let m = lis[0].querySelector(".date").getAttribute("month");
        lis.forEach(li => {
            let d = li.innerText;
            let divEvents = li.querySelector(".events");
            li.onclick = this.onDateClick;
            let year;
            let month;
            let day;
            let weekday;

            this.data.forEach(ev => {
                let evTime = moment(ev.eventDateStart);
                if (
                    evTime.year() == y &&
                    evTime.month() == m &&
                    evTime.date() == d
                ) {
                    year = evTime.year();
                    month = evTime.month();
                    day = evTime.date();
                    weekday = evTime.isoWeekday();
                    let frgEvent = document.createRange()
                        .createContextualFragment(`
                        <div time="${ev.eventDateStart}" class="event ${ev.cls}"><a href="${ev.eventPage}">${ev.description}</a>
                        `);
                    divEvents.appendChild(frgEvent);
                    let divEvent = divEvents.querySelector(
                        `.event[time='${ev.eventDateStart}']`
                    );
                    // divEvent.onclick = this.onEventClick;
                }
            });
            // <div time="${ev.time}" data-id="${ev.id}" class="event ${ev.cls}">${ev.desc}</div>

            //hide events after the 3rd
            //TODO: INDICATOR THAT THERES MORE THAN 3 on each day in calendar view
            if (li.querySelectorAll(".event").length > 3) {
                let eventList = li.querySelectorAll(".event");
                for (let i = 0; i < eventList.length; i++) {
                    if (i > 2) {
                        eventList[i].style.display = "none";
                    }
                }
            }

            // Meatballs / See events for one day
            if (!deviceMobile) {
                if (li.querySelectorAll(".event").length >= 1) {
                    let meatballs = document.createElement("img");
                    meatballs.setAttribute("src", "/Images/meatballs.png");
                    meatballs.setAttribute("alt", "flere events");

                    meatballs.setAttribute("data-year", year);
                    meatballs.setAttribute("data-month", month);
                    meatballs.setAttribute("data-day", day);
                    meatballs.setAttribute("data-weekday", weekday);
                    meatballs.onclick = this.onMeatballClick;
                    meatballs.classList.add("meatballs");
                    li.appendChild(meatballs);
                }
            } else {
                if (li.querySelectorAll(".event").length >= 1) {
                    let mobileEvent = document.createElement("div");
                    li.setAttribute("data-id", "123");
                    li.setAttribute("data-year", year);
                    li.setAttribute("data-month", month);
                    li.setAttribute("data-day", day);
                    li.setAttribute("data-weekday", weekday);
                    mobileEvent.classList.add("mobileEvent");
                    li.appendChild(mobileEvent);
                    li.onclick = this.onMobileDayClick;
                }
            }
        });
    },
    // ${evTime.format("h:mma")}
    render(y, m) {
        if (isNaN(y) && isNaN(this.y)) {
            this.y = moment().year();
        } else if (
            (!isNaN(y) && isNaN(this.y)) ||
            (!isNaN(y) && !isNaN(this.y))
        ) {
            this.y = y > 1600 ? y : moment().year();
        }
        if (isNaN(m) && isNaN(this.m)) {
            this.m = moment().month();
        } else if (
            (!isNaN(m) && isNaN(this.m)) ||
            (!isNaN(m) && !isNaN(this.m))
        ) {
            this.m = m >= 0 ? m : moment().month();
        }

        const d = moment()
            .year(this.y)
            .month(this.m)
            .date(1);
        const now = moment();
        const frgCal = document.createRange().createContextualFragment(`
        <div class="calendar noselect p-5">
        
        <div class="month-year-btn d-flex justify-content-center align-items-center mb-2">
            <div class="month-year d-flex justify-content-center align-items-center">
            <div class="month mb-2 mr-2">${moment()
                .month(this.m)
                .format("MMMM")}
            </div>
            <div class="year mb-2">${this.y}</div>
            </div>
        </div>

            <ol class="day-names list-unstyled">
                <li><h6 class="initials">Mandag</h6></li>
                <li><h6 class="initials">Tirsdag</h6></li>
                <li><h6 class="initials">Onsdag</h6></li>
                <li><h6 class="initials">Torsdag</h6></li>
                <li><h6 class="initials">Fredag</h6></li>
                <li><h6 class="initials">Lørdag</h6></li>
                <li><h6 class="initials">Søndag</h6></li>
            </ol>
        </div>
        `);

        const isSameDate = (d1, d2) =>
            d1.format("YYYY-MM-DD") == d2.format("YYYY-MM-DD");
        let frgWeek;

        var getDaysInMonth = function(month, year) {
            return new Date(year, month + 1, 0).getDate();
        };

        // To determine how many rows of weeks there should be
        let weeks = 5;
        let month = d.month();
        let year = d.year();
        let numOfDays = getDaysInMonth(month, year);
        if (d.day() === 6 && numOfDays === 31) {
            weeks = 6;
        } else if (d.day() === 0 && numOfDays >= 30) {
            weeks = 6;
        }

        if (d.day() == 0) {
            // If the first is on a friday / saturday / sunday => add an extra week en the beginning (d.day(-7))
            d.day(-7);
        } else {
            d.day(0);
        }

        // How many rows of weeks. Now = 6
        for (let i = 0; i < weeks; i++) {
            // loop thru (NumOfWeeks * 7) boxes on the calendar month
            frgWeek = document.createRange().createContextualFragment(`
            <ol class="days list-unstyled" week="${d.week()}">

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>

                <li class="${(d.add(1, "d"),
                this.m != d.month() ? " outside" : "inside")}${
                isSameDate(d, now) ? " today" : ""
            }"><div month="${d.month()}" class="date">${d.format(
                "D"
            )}</div><div class="events"></div></li>
            </ol>
            `);
            frgCal.querySelector(".calendar").appendChild(frgWeek);
        }

        document.querySelector("#prevMonth").onclick = () => {
            const dp = moment()
                .year(this.y)
                .month(this.m)
                .date(1)
                .subtract(1, "month");
            this.render(dp.year(), dp.month());
            $("#currentMonth").text(monthNames[this.m]);
            $("#currentYear").text(this.y);
            $("#prevMonthLabel").text(monthNames[this.m - 1]);
            $("#nextMonthLabel").text(monthNames[this.m + 1]);
            findDataWithDate(this.m, this.y);
            calendarDownload();
        };
        document.querySelector("#nextMonth").onclick = () => {
            const dn = moment()
                .year(this.y)
                .month(this.m)
                .date(1)
                .add(1, "month");
            this.render(dn.year(), dn.month());
            $("#currentMonth").text(monthNames[this.m]);
            $("#currentYear").text(this.y);
            $("#prevMonthLabel").text(monthNames[this.m - 1]);
            $("#nextMonthLabel").text(monthNames[this.m + 1]);
            findDataWithDate(this.m, this.y);
            calendarDownload();
        };
        this.el = document.getElementById(this.id);
        this.el.innerHTML = ""; //replacing
        this.el.appendChild(frgCal);
        this.renderEvents();
    }
});

document.addEventListener("DOMContentLoaded", async () => {
    if (document.getElementById("calendar")) {
        const cal = Calendar("calendar");
        const spr = Spinner("calendar");
        await spr.renderSpinner().delay(0);
        cal.bindData(newData);
        cal.render();
    }
});

// CALENDAR DOWNLOAD FUNCTIONALITY

let singleBtnArr;

const calendarDownload = () => {
    if (document.getElementsByClassName("calendar-download")) {
        singleBtnArr = document.getElementsByClassName("calendar-download");

        //cal.addEvent('Demo Event', 'This is thirty minute event', 'Nome, AK', '8/7/2013 5:30 pm', '8/7/2013 6:00 pm');

        for (let i = 0; i < singleBtnArr.length; i++) {
            let cal_file = ics();
            let data = singleBtnArr[i].dataset;
            let eventTitle = "";
            if (data.eventtitle) {
                eventTitle = data.eventtitle;
            }

            let eventDesc = "";
            if (data.eventdesc) {
                eventDesc = data.eventdesc;
            }

            let eventLocation = "";
            if (data.eventlocation) {
                eventLocation = data.eventlocation;
            }

            let eventStart = data.eventdatestart;

            // TODO: when backend has enddate => add it here.
            let eventEnd;
            if (
                !data.eventdateend ||
                data.eventdateend === data.eventdatestart
            ) {
                let start = new Date(data.eventdatestart);
                start.setMinutes(start.getMinutes() - 1);
                eventEnd = start.setHours(start.getHours() + 1);
            } else {
                eventEnd = data.eventdateend;
            }

            cal_file.addEvent(
                eventTitle,
                eventDesc,
                eventLocation,
                eventStart,
                eventEnd
            );

            singleBtnArr[i].onclick = function(e) {
                e.preventDefault();
                cal_file.download("SDG-event-TEST");
            };
        }
    }
};

$(document).ready(function() {
    calendarDownload();
});

// * ics.deps.min.js
// For downloading calendar events
/*! ics.js */
var saveAs =
    saveAs ||
    (function(e) {
        "use strict";
        if (
            typeof e === "undefined" ||
            (typeof navigator !== "undefined" &&
                /MSIE [1-9]\./.test(navigator.userAgent))
        ) {
            return;
        }
        var t = e.document,
            n = function() {
                return e.URL || e.webkitURL || e;
            },
            r = t.createElementNS("http://www.w3.org/1999/xhtml", "a"),
            o = "download" in r,
            a = function(e) {
                var t = new MouseEvent("click");
                e.dispatchEvent(t);
            },
            i = /constructor/i.test(e.HTMLElement) || e.safari,
            f = /CriOS\/[\d]+/.test(navigator.userAgent),
            u = function(t) {
                (e.setImmediate || e.setTimeout)(function() {
                    throw t;
                }, 0);
            },
            s = "application/octet-stream",
            d = 1e3 * 40,
            c = function(e) {
                var t = function() {
                    if (typeof e === "string") {
                        n().revokeObjectURL(e);
                    } else {
                        e.remove();
                    }
                };
                setTimeout(t, d);
            },
            l = function(e, t, n) {
                t = [].concat(t);
                var r = t.length;
                while (r--) {
                    var o = e["on" + t[r]];
                    if (typeof o === "function") {
                        try {
                            o.call(e, n || e);
                        } catch (a) {
                            u(a);
                        }
                    }
                }
            },
            p = function(e) {
                if (
                    /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(
                        e.type
                    )
                ) {
                    return new Blob([String.fromCharCode(65279), e], {
                        type: e.type
                    });
                }
                return e;
            },
            v = function(t, u, d) {
                if (!d) {
                    t = p(t);
                }
                var v = this,
                    w = t.type,
                    m = w === s,
                    y,
                    h = function() {
                        l(v, "writestart progress write writeend".split(" "));
                    },
                    S = function() {
                        if ((f || (m && i)) && e.FileReader) {
                            var r = new FileReader();
                            r.onloadend = function() {
                                var t = f
                                    ? r.result
                                    : r.result.replace(
                                          /^data:[^;]*;/,
                                          "data:attachment/file;"
                                      );
                                var n = e.open(t, "_blank");
                                if (!n) e.location.href = t;
                                t = undefined;
                                v.readyState = v.DONE;
                                h();
                            };
                            r.readAsDataURL(t);
                            v.readyState = v.INIT;
                            return;
                        }
                        if (!y) {
                            y = n().createObjectURL(t);
                        }
                        if (m) {
                            e.location.href = y;
                        } else {
                            var o = e.open(y, "_blank");
                            if (!o) {
                                e.location.href = y;
                            }
                        }
                        v.readyState = v.DONE;
                        h();
                        c(y);
                    };
                v.readyState = v.INIT;
                if (o) {
                    y = n().createObjectURL(t);
                    setTimeout(function() {
                        r.href = y;
                        r.download = u;
                        a(r);
                        h();
                        c(y);
                        v.readyState = v.DONE;
                    });
                    return;
                }
                S();
            },
            w = v.prototype,
            m = function(e, t, n) {
                return new v(e, t || e.name || "download", n);
            };
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            return function(e, t, n) {
                t = t || e.name || "download";
                if (!n) {
                    e = p(e);
                }
                return navigator.msSaveOrOpenBlob(e, t);
            };
        }
        w.abort = function() {};
        w.readyState = w.INIT = 0;
        w.WRITING = 1;
        w.DONE = 2;
        w.error = w.onwritestart = w.onprogress = w.onwrite = w.onabort = w.onerror = w.onwriteend = null;
        return m;
    })(
        (typeof self !== "undefined" && self) ||
            (typeof window !== "undefined" && window) ||
            this.content
    );

if (typeof module !== "undefined" && module.exports) {
    module.exports.saveAs = saveAs;
} else if (
    typeof define !== "undefined" &&
    define !== null &&
    define.amd !== null
) {
    define("FileSaver.js", function() {
        return saveAs;
    });
}

var ics = function(e, t) {
    "use strict";
    {
        if (
            !(
                navigator.userAgent.indexOf("MSIE") > -1 &&
                -1 == navigator.userAgent.indexOf("MSIE 10")
            )
        ) {
            void 0 === e && (e = "default"), void 0 === t && (t = "Calendar");
            var r = -1 !== navigator.appVersion.indexOf("Win") ? "\r\n" : "\n",
                n = [],
                i = ["BEGIN:VCALENDAR", "PRODID:" + t, "VERSION:2.0"].join(r),
                o = r + "END:VCALENDAR",
                a = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
            return {
                events: function() {
                    return n;
                },
                calendar: function() {
                    return i + r + n.join(r) + o;
                },
                addEvent: function(t, i, o, l, u, s) {
                    if (
                        void 0 === t ||
                        void 0 === i ||
                        void 0 === o ||
                        void 0 === l ||
                        void 0 === u
                    )
                        return !1;
                    if (s && !s.rrule) {
                        if (
                            "YEARLY" !== s.freq &&
                            "MONTHLY" !== s.freq &&
                            "WEEKLY" !== s.freq &&
                            "DAILY" !== s.freq
                        )
                            throw "Recurrence rrule frequency must be provided and be one of the following: 'YEARLY', 'MONTHLY', 'WEEKLY', or 'DAILY'";
                        if (s.until && isNaN(Date.parse(s.until)))
                            throw "Recurrence rrule 'until' must be a valid date string";
                        if (s.interval && isNaN(parseInt(s.interval)))
                            throw "Recurrence rrule 'interval' must be an integer";
                        if (s.count && isNaN(parseInt(s.count)))
                            throw "Recurrence rrule 'count' must be an integer";
                        if (void 0 !== s.byday) {
                            if (
                                "[object Array]" !==
                                Object.prototype.toString.call(s.byday)
                            )
                                throw "Recurrence rrule 'byday' must be an array";
                            if (s.byday.length > 7)
                                throw "Recurrence rrule 'byday' array must not be longer than the 7 days in a week";
                            s.byday = s.byday.filter(function(e, t) {
                                return s.byday.indexOf(e) == t;
                            });
                            for (var c in s.byday)
                                if (a.indexOf(s.byday[c]) < 0)
                                    throw "Recurrence rrule 'byday' values must include only the following: 'SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'";
                        }
                    }
                    var g = new Date(l),
                        d = new Date(u),
                        f = new Date(),
                        S = ("0000" + g.getFullYear().toString()).slice(-4),
                        E = ("00" + (g.getMonth() + 1).toString()).slice(-2),
                        v = ("00" + g.getDate().toString()).slice(-2),
                        y = ("00" + g.getHours().toString()).slice(-2),
                        A = ("00" + g.getMinutes().toString()).slice(-2),
                        T = ("00" + g.getSeconds().toString()).slice(-2),
                        b = ("0000" + d.getFullYear().toString()).slice(-4),
                        D = ("00" + (d.getMonth() + 1).toString()).slice(-2),
                        N = ("00" + d.getDate().toString()).slice(-2),
                        h = ("00" + d.getHours().toString()).slice(-2),
                        I = ("00" + d.getMinutes().toString()).slice(-2),
                        R = ("00" + d.getMinutes().toString()).slice(-2),
                        M = ("0000" + f.getFullYear().toString()).slice(-4),
                        w = ("00" + (f.getMonth() + 1).toString()).slice(-2),
                        L = ("00" + f.getDate().toString()).slice(-2),
                        O = ("00" + f.getHours().toString()).slice(-2),
                        p = ("00" + f.getMinutes().toString()).slice(-2),
                        Y = ("00" + f.getMinutes().toString()).slice(-2),
                        U = "",
                        V = "";
                    y + A + T + h + I + R != 0 &&
                        ((U = "T" + y + A + T), (V = "T" + h + I + R));
                    var B,
                        C = S + E + v + U,
                        j = b + D + N + V,
                        m = M + w + L + ("T" + O + p + Y);
                    if (s)
                        if (s.rrule) B = s.rrule;
                        else {
                            if (((B = "rrule:FREQ=" + s.freq), s.until)) {
                                var x = new Date(
                                    Date.parse(s.until)
                                ).toISOString();
                                B +=
                                    ";UNTIL=" +
                                    x
                                        .substring(0, x.length - 13)
                                        .replace(/[-]/g, "") +
                                    "000000Z";
                            }
                            s.interval && (B += ";INTERVAL=" + s.interval),
                                s.count && (B += ";COUNT=" + s.count),
                                s.byday &&
                                    s.byday.length > 0 &&
                                    (B += ";BYDAY=" + s.byday.join(","));
                        }
                    new Date().toISOString();
                    var H = [
                        "BEGIN:VEVENT",
                        "UID:" + n.length + "@" + e,
                        "CLASS:PUBLIC",
                        "DESCRIPTION:" + i,
                        "DTSTAMP;VALUE=DATE-TIME:" + m,
                        "DTSTART;VALUE=DATE-TIME:" + C,
                        "DTEND;VALUE=DATE-TIME:" + j,
                        "LOCATION:" + o,
                        "SUMMARY;LANGUAGE=en-us:" + t,
                        "TRANSP:TRANSPARENT",
                        "END:VEVENT"
                    ];
                    return (
                        B && H.splice(4, 0, B), (H = H.join(r)), n.push(H), H
                    );
                },
                download: function(e, t) {
                    if (n.length < 1) return !1;
                    (t = void 0 !== t ? t : ".ics"),
                        (e = void 0 !== e ? e : "calendar");
                    var a,
                        l = i + r + n.join(r) + o;
                    if (-1 === navigator.userAgent.indexOf("MSIE 10"))
                        a = new Blob([l]);
                    else {
                        var u = new BlobBuilder();
                        u.append(l),
                            (a = u.getBlob(
                                "text/x-vCalendar;charset=" +
                                    document.characterSet
                            ));
                    }
                    return saveAs(a, e + t), l;
                },
                build: function() {
                    return !(n.length < 1) && i + r + n.join(r) + o;
                }
            };
        }
        console.log("Unsupported Browser");
    }
};
